import type { FC, ReactNode } from 'react';

import classNames from 'classnames';

import { ListHeader } from '../ListHeader/ListHeader';

import * as styles from './List.module.scss';

export interface ListProps {
  header?: string;
  children: ReactNode;
  className?: string;
}

const List: FC<ListProps> = ({ header, children, className }) => {
  const itemsToRender = Array.isArray(children) ? children : [children];

  return (
    <div>
      {header ? <ListHeader headerContent={header} /> : null}
      <ul className={classNames(className, styles.list)}>
        {itemsToRender.map((childItem, index) => (
          <li key={index}>{childItem}</li>
        ))}
      </ul>
    </div>
  );
};

export { List };
